<mat-form-field appearance="outline" *ngIf="userTenantsOptions && userTenantsOptions.length>1">
  <mat-select id="switch-tenant" [value]="currentTenantId" (valueChange)="switchTenantId.emit($event)">
    <ng-container *ngFor="let item of userTenantsOptions">
      <mat-option [value]="item.value">{{ item.name }}</mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>